import { render, staticRenderFns } from "./VueHtml2pdf.vue?vue&type=template&id=f498c778&scoped=true&"
import script from "./VueHtml2pdf.vue?vue&type=script&lang=js&"
export * from "./VueHtml2pdf.vue?vue&type=script&lang=js&"
import style0 from "./VueHtml2pdf.vue?vue&type=style&index=0&id=f498c778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f498c778",
  null
  
)

export default component.exports